import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { useForm, useFieldArray } from "react-hook-form";
import useGlobalState from "../../Context";
import {
  Button,
  Grid,
  Box,
  Divider,
  FormLabel,
  Typography,
  FormControl,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { VENDOR_APPOINTMENT_STEP_3 } from "../../utils/Validation";
import { isEmptyObject, padGSTIN } from "../../utils/jsUtils";

const Step2 = ({
  onClickNext,
  handleBack,
  setFormData,
  formData,
  noOfVehicle,
  vehicleTypeList,
}) => {
  const [{ userDetails }] = useGlobalState();
  const userParam = userDetails?.userParam;

  const formOption = {
    resolver: yupResolver(VENDOR_APPOINTMENT_STEP_3),
    defaultValues: {
      ...formData,
      vendorSpocName: userParam?.firstName + " " + userParam?.lastName,
      vendorSpocEmail: userParam?.email,
      vendorMobileNo: userParam?.mobile,
      vendorCode: userParam?.vendorCode,
      vendorName: userParam?.vendorName,
      GSTIN: padGSTIN(userParam?.gstin),
    },
  };
  const {
    register,
    watch,
    control,
    handleSubmit,

    formState: { errors },
  } = useForm(formOption);
  const { fields, append, remove } = useFieldArray({
    name: "vehicleDetails",
    control,
  });

  const countOfVechileWatch = watch("countOfvehicle") ?? 1;
  useEffect(() => {
    const newVal = parseInt(countOfVechileWatch || 1);
    const oldVal = fields.length;
    if (newVal > oldVal) {
      for (let i = oldVal; i < newVal; i++) {
        append({
          vehicleType: "",
          vrn: "",
          driverName: "",
          driverContactNumber: "",
        });
      }
    } else {
      for (let i = oldVal; i > newVal; i--) {
        remove(i - 1);
      }
    }
  }, [append, countOfVechileWatch, fields.length, remove]);

  const onSubmit = (data) => {
    const filteredData = {
      ...data,
      vehicleDetails: parseVehicleDetails(data?.vehicleDetails),
    };
    setFormData({ ...formData, ...filteredData });

    onClickNext();
  };

  const parseVehicleDetails = (vehicleDetails) => {
    return vehicleDetails?.filter(
      (vehicleDetail) => !isEmptyObject(vehicleDetail)
    );
  };

  return (
    <>
      <Grid className="bg-white">
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 4 }}>
            <Box>
              <form>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  textAlign={"left"}
                  ml={2}
                  mb={1}
                >
                  <Grid item xs={12} sm={12}>
                    <Typography variant="h6">Vendor Details</Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  mb={2}
                  pl={4}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display="flex"
                    flexDirection="column"
                    px={1}
                    md={4}
                    justifyContent="left"
                    alignContent="left"
                  >
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Vendor SPOC Name{" "}
                    </FormLabel>
                    <TextField
                      className="stepperFormInput2"
                      name="vendorSpocName"
                      fullWidth
                      disabled
                      size="small"
                      required
                      autoComplete="off"
                      {...register("vendorSpocName", { required: true })}
                      error={Boolean(errors?.vendorSpocName)}
                      helperText={
                        errors?.vendorSpocName ? "This field is required" : ""
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display="flex"
                    flexDirection="column"
                    px={1}
                    md={4}
                    justifyContent="left"
                    alignContent="left"
                  >
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Vendor SPOC Email{" "}
                    </FormLabel>
                    <TextField
                      className="stepperFormInput2"
                      name="vendorSpocEmail"
                      fullWidth
                      disabled
                      size="small"
                      required
                      autoComplete="off"
                      {...register("vendorSpocEmail", { required: true })}
                      error={Boolean(errors?.vendorSpocEmail)}
                      helperText={
                        errors?.vendorSpocEmail ? "This field is required" : ""
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display="flex"
                    flexDirection="column"
                    px={1}
                    md={4}
                    justifyContent="left"
                    alignContent="left"
                  >
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Mobile Number{" "}
                    </FormLabel>
                    <TextField
                      className="stepperFormInput2"
                      name="vendorMobileNo"
                      fullWidth
                      disabled
                      size="small"
                      autoComplete="off"
                      {...register("vendorMobileNo", { required: true })}
                      error={Boolean(errors?.materialType)}
                    ></TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display="flex"
                    flexDirection="column"
                    px={1}
                    md={4}
                    justifyContent="left"
                    alignContent="left"
                  >
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Vendor Code{" "}
                    </FormLabel>
                    <TextField
                      className="stepperFormInput2"
                      name="vendorCode"
                      fullWidth
                      disabled
                      size="small"
                      required
                      autoComplete="off"
                      {...register("vendorCode", { required: true })}
                      error={Boolean(errors?.vendorCode)}
                      helperText={
                        errors?.vendorCode ? "This field is required" : ""
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display="flex"
                    flexDirection="column"
                    px={1}
                    md={4}
                    justifyContent="left"
                    alignContent="left"
                  >
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Vendor Name{" "}
                    </FormLabel>
                    <TextField
                      className="stepperFormInput2"
                      name="vendorName"
                      fullWidth
                      disabled
                      size="small"
                      required
                      autoComplete="off"
                      {...register("vendorName", { required: true })}
                      error={Boolean(errors?.vendorName)}
                      helperText={
                        errors?.vendorName ? "This field is required" : ""
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display="flex"
                    flexDirection="column"
                    px={1}
                    md={4}
                    justifyContent="left"
                    alignContent="left"
                  >
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Destination FC{" "}
                    </FormLabel>
                    <TextField
                      className="stepperFormInput2"
                      name="destinationFC"
                      fullWidth
                      disabled
                      size="small"
                      required
                      autoComplete="off"
                      value={` ${formData?.fcCode} - ${formData?.fcName}`}
                    />
                  </Grid>
                </Grid>

                <Divider />
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  textAlign={"left"}
                  ml={2}
                  mt={1}
                  mb={1}
                >
                  <Grid item xs={12} sm={6}>
                    <Typography variant="h6">Vehicle Details</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={5}
                    md={5}
                    justifyContent="right"
                    alignItems="right"
                    direction="row"
                    textAlign={"right"}
                  >
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        width: "150px",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Count of Vehicle
                    </FormLabel>
                    <TextField
                      className="stepperFormInput5"
                      name="countOfvehicle"
                      select
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                      defaultValue={countOfVechileWatch}
                      {...register("countOfvehicle")}
                      error={Boolean(errors?.countOfvehicle)}
                      helperText={errors?.countOfvehicle?.message}
                    >
                      {[...Array(noOfVehicle + 1)].map((option, i) => (
                        <MenuItem key={i} value={i}>
                          {i}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={1}
                    md={1}
                    justifyContent="right"
                    alignItems="right"
                    direction="row"
                    textAlign={"right"}
                  ></Grid>
                </Grid>
                <Grid item xs={12} md={12} sx={{ px: 2, py: 0 }}>
                  {fields.map((val, index) => {
                    return (
                      <Box
                        sx={{
                          m: 2,
                          p: 1.5,
                          borderRadius: 2,
                          borderColor: "#4d6fa552",
                          borderStyle: "solid",
                          borderWidth: "2px",
                        }}
                      >
                        <Grid container spacing={2} sx={{ pb: 3 }}>
                        <Grid item xs={12} sm={0.4}>
                            <Box
                              py={0.5}
                              px={1.5}
                              sx={{
                                backgroundColor: "#e7e7e7",
                                borderRadius: 2,
                              }}
                            >
                              <Typography variant="h6">{index + 1}</Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={11.6 / 4}>
                            <FormLabel
                              className="stepperFormLabel"
                              sx={{
                                float: "left",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Vehicle Type
                            </FormLabel>
                            <FormControl sx={{ width: "100%" }}>
                              <TextField
                                name={`vehicleDetails[${index}]vehicleTypeId`}
                                select
                                fullWidth
                                size="small"
                                autoComplete="off"
                                defaultValue={val?.vehicleTypeId}
                                {...register(
                                  `vehicleDetails[${index}].vehicleTypeId`
                                )}
                              >
                                {vehicleTypeList.length > 0 &&
                                  vehicleTypeList.map((option) => (
                                    <MenuItem
                                      key={option.vehicleTypeId}
                                      value={option.vehicleTypeId}
                                    >
                                      {option.vehicleType}
                                    </MenuItem>
                                  ))}
                              </TextField>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={11.6 / 4}>
                            <FormLabel
                              className="stepperFormLabel"
                              sx={{
                                float: "left",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Vehicle Registration Number
                            </FormLabel>
                            <FormControl sx={{ width: "100%" }}>
                              <TextField
                                inputProps={{ maxLength: 10 }}
                                type="text"
                                name={`vehicleDetails[${index}]vrn`}
                                fullWidth
                                size="small"
                                autoComplete="off"
                                {...register(`vehicleDetails[${index}].vrn`)}
                                error={
                                  !!errors?.vehicleDetails?.[index]?.vrn
                                    ? Boolean(
                                        `${errors?.vehicleDetails?.[index]?.vrn}`
                                      )
                                    : false
                                }
                                helperText={
                                  !!errors?.vehicleDetails?.[index]?.vrn
                                    ?.message
                                    ? `${errors?.vehicleDetails?.[index]?.vrn?.message}`
                                    : ""
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={11.6 / 4}>
                            <FormLabel
                              className="stepperFormLabel"
                              sx={{
                                float: "left",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Driver Names
                            </FormLabel>
                            <FormControl sx={{ width: "100%" }}>
                              <TextField
                                type="text"
                                fullWidth
                                name={`vehicleDetails[${index}]driverName`}
                                size="small"
                                autoComplete="off"
                                {...register(
                                  `vehicleDetails[${index}].driverName`
                                )}
                              />
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={11.6 / 4}>
                            <FormLabel
                              className="stepperFormLabel"
                              sx={{
                                float: "left",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Driver Contact Number
                            </FormLabel>
                            <FormControl sx={{ width: "100%" }}>
                              <TextField
                                type="number"
                                fullWidth
                                size="small"
                                name={`vehicleDetails[${index}]driverContactNumber`}
                                autoComplete="off"
                                {...register(
                                  `vehicleDetails[${index}].driverContactNumber`
                                )}
                                error={
                                  !!errors?.vehicleDetails?.[index]
                                    ?.driverContactNumber
                                    ? Boolean(
                                        `${errors?.vehicleDetails?.[index]?.driverContactNumber}`
                                      )
                                    : false
                                }
                                helperText={
                                  !!errors?.vehicleDetails?.[index]
                                    ?.driverContactNumber?.message
                                    ? `${errors?.vehicleDetails?.[index]?.driverContactNumber?.message}`
                                    : ""
                                }
                              />
                            </FormControl>
                          </Grid>
                          </Grid>
                      </Box>
                    );
                  })}
                </Grid>
              </form>
            </Box>
          </Grid>
          <Divider />
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", p: 2 }}>
              <Button
                variant="outlined"
                // disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                sx={{ mr: 1 }}
                variant="outlined"
              >
                Next
              </Button>
            </Box>
          </React.Fragment>
        </Grid>
      </Grid>
    </>
  );
};
export default Step2;
